import React, { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';

import store, { history } from '@/store';
import { getMe } from '@/store/actions/login';
import { hydrateResponses } from '@/store/responses';

import App from '@/containers/App';

import '@/pwa/init';

// A storage read that never settles must not keep the app from mounting.
const HYDRATE_TIMEOUT_MS = 500;

// Stored responses are read before anything asks for them, so the first render
// already has the last copy of the profile and of every screen. getMe is
// dispatched here rather than at App's module scope for that reason: it is the
// first request, and the route guards show a Loader until it lands.
Promise.race([
  hydrateResponses(),
  new Promise((resolve) => { setTimeout(resolve, HYDRATE_TIMEOUT_MS); }),
]).then(() => {
  store.dispatch<any>(getMe(true));

  ReactDOM.render(
    <StrictMode>
      <BrowserRouter>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </Provider>
      </BrowserRouter>
    </StrictMode>,
    document.getElementById('root'),
  );
});
